import ChangePassowrd from "./ChangePassowrd";
import ThemeChange from "./ThemeChange";
// import { SetMiniTabs } from "../../Tools/Tools";
import { Grid } from "@mui/material";
import { AxiosRequest, getOptionsForUser } from "../../../Url";
import React, { useEffect, useState } from "react";
import WorkSpaceInstall from "../../Tools/WorkSpaceInstall";
import SmetaTabs from "../../Tools/Tabs/SmetaTabs";
import { SmetaTabItem } from "../../Tools/Tabs/PinIcons";
import { useAtomValue } from "jotai";
import { appConfig } from "../../../../atoms";

export default function Options() {
  const config = useAtomValue(appConfig);
  const IP = getOptionsForUser()?.IP;
  const [ServerInfo, setServerInfo] = useState({});

  useEffect(() => {
    let params = new Map();
    params.set("comand", "Info");
    params.set("Info", "1");
    params.set("JSON", "1");
    AxiosRequest(true, params).then((res) => {
      setServerInfo(res);
    });
  }, []);
  return (
    <SmetaTabs id="optionsForUser" style={{ width: "100%", height: "98%" }}>
      <SmetaTabItem
        id={"ChangePassowrdTab"}
        label={"Безопасность"}
        style={{
          textTransform: "none",
          width: "100%",
          height: "100%",
          padding: "0px",
          display: "inline-block",
        }}
      >
        <ChangePassowrd />
      </SmetaTabItem>
      <SmetaTabItem
        id={"ThemeTab"}
        label={"Оформление"}
        style={{
          textTransform: "none",
          width: "100%",
          height: "100%",
          padding: "0px",
          display: "inline-block",
        }}
      >
        <ThemeChange />
      </SmetaTabItem>
      <SmetaTabItem
        id={"AboutTab"}
        label={"О сайте"}
        style={{
          textTransform: "none",
          width: "100%",
          height: "100%",
          padding: "0px",
          display: "inline-block",
        }}
      >
        <Grid
          container
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          style={{ height: "100%", paddingLeft: 4, paddingTop: 4 }}
          spacing={1}
          // xs={{ m: 4 }}
        >
          <Grid item>{`Версия сайта: ${config.smeta.stimateVersion}`}</Grid>
          <Grid item>{`Версия сервера: ${ServerInfo.Version}`}</Grid>
          <Grid
            item
            onClick={() => {
              navigator.clipboard.writeText(sessionStorage.getItem("LicG"));
            }}
          >{`Идентификатор сессии: ${sessionStorage.getItem("LicG")}`}</Grid>
          {IP !== undefined && !config.smeta.hideServerRedirection && (
            <Grid item sx>{`Сервер перенаправления: ${IP}`}</Grid>
          )}
        </Grid>
      </SmetaTabItem>
      <SmetaTabItem
        id={"ChangePassowrdTab"}
        label={"Крипто-плагин"}
        style={{
          textTransform: "none",
          width: "100%",
          height: "100%",
          padding: "0px",
          display: "inline-block",
        }}
      >
        <WorkSpaceInstall />
      </SmetaTabItem>
    </SmetaTabs>
  );
}
